import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TravelSchedulerTask } from '../../../interfaces/travel-scheduler/travel-scheduler-task';
import { ScheduleTaskSequenceTaskComponent } from '../schedule-task-sequence-task/schedule-task-sequence-task.component';
import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'schedule-task-sequence',
  standalone: true,
  imports: [CommonModule, ScheduleTaskSequenceTaskComponent, DragDropModule],
  templateUrl: './schedule-task-sequence.component.html',
  styleUrls: ['./schedule-task-sequence.component.css'],
})
export class ScheduleTaskSequenceComponent implements OnInit {
  @Input() tasks!: TravelSchedulerTask[];
  @Output() taskSequenceChanged = new EventEmitter<TravelSchedulerTask[]>();
  constructor() {}

  ngOnInit(): void {}

  protected drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.tasks, event.previousIndex, event.currentIndex);
    this.taskSequenceChanged.emit(this.tasks);
  }

  protected shiftTaskPosition(taskIndex: number, positionShift: number) {
    moveItemInArray(this.tasks, taskIndex, taskIndex + positionShift);
    this.taskSequenceChanged.emit(this.tasks);
  }
}
